import React, { useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import IONSite from './IONSite'
//import reportWebVitals from './reportWebVitals'
import { QueryClient,  QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'

import './scss/Settings.scss'
import './scss/Base.scss';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            staleTime: 900000, // 15 mins
        },
    }
  });

const OptinMonsterScript = () => {
    const env = process.env.REACT_APP_ENV;

    useEffect(() => {
        if (env === "staging" || env === "production") {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.innerHTML = `
                (function(d,u,ac){
                    var s=d.createElement('script');
                    s.type='text/javascript';
                    s.src='https://a.omappapi.com/app/js/api.min.js';
                    s.async=true;
                    s.dataset.user=u;
                    s.dataset.account=ac;
                    d.getElementsByTagName('head')[0].appendChild(s);
                })(document,27375,2863);
            `;
            document.body.appendChild(script);
        }
    }, [env]);

    return null;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <>
        <OptinMonsterScript />
        <React.StrictMode>
            <QueryClientProvider client={queryClient}>
                <HelmetProvider>
                    <BrowserRouter>
                        <IONSite />
                    </BrowserRouter>
                </HelmetProvider>
                <ReactQueryDevtools initialIsOpen={false} />
            </QueryClientProvider>
        </React.StrictMode>
    </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
